
import Vue from "vue";
import { AutoSaleRowSetting } from "@/models/auto-sale-row-setting";
import { IDataTableColumn } from "winfakt-vue-components";
import { AutoSaleRowSettingsService } from "@/services/auto-sale-row-settings-service";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";

export default Vue.extend({
	data(){
		return {
			settings: [] as AutoSaleRowSetting[],
			selectedRows: [] as AutoSaleRowSetting[]
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		value: {
			type: Object as ()=>Dossier,
			required: true
		},
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "ID",
					width: "40px",
				},
				{
					name: "Omschrijving",
					property: "Description",
					width: "800px",
				},
			];
		},
		selectedItem():AutoSaleRowSetting | null {
			if (this.selectedRows.length != 1) {
				return null;
			}
			return this.selectedRows[0];
		}
	},
	methods: {
		compare(s1:AutoSaleRowSetting, s2:AutoSaleRowSetting):boolean{
			return s1.ID == s2.ID;
		},
		add(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/auto-sale-row-setting/new`);
		},
		edit(){
			if (!this.selectedItem) return;
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/auto-sale-row-setting/edit/${this.selectedItem.ID}`);
		},
		async remove(){
			let result = await this.$wf.confirm(`Weet je zeker dat je ${this.selectedRows.length} item(s) wilt verwijderen`, "Ja", "Nee");
			if (!result) return;
			for (let item of this.selectedRows){
				await AutoSaleRowSettingsService.deleteSetting(this.value.id, item);
			}
			this.selectedRows = [];
			this.fetch();
		},
		async fetch(){
			this.settings = await AutoSaleRowSettingsService.getAllSettings(this.value.id);
		},
	},
	mounted(){
		this.fetch();
	},
});
